module.exports = __webpack_public_path__ + "img/c_4_3.81c7987d.jpg";